export default function auditorReducer(state = {
    blocking: false
  }, action) {
      switch(action.type){
        case "SET_BLOCKING_STATE":
        return Object.assign({}, state, { blocking: action.payload });
        case "AUDITOR_DATA":
        var auditorUser ={
            user:action.user,
        }
        console.log("AuditorUser:", auditorUser);
        return Object.assign({},state,{auditorUser:auditorUser});
        default:
        return state
      }
  };